// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox_searchBox__rlIp1","input":"SearchBox_input__qD516"};